import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import { instance } from "Actions/AxiosInstance";
import DynamicForm from "Component/DynamicForm";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { ErrorMessages } from "Constants";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import ReactQuill from "react-quill";
import { convertTOBase64 } from "Utils";
import "./index.scss";

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
]; // 'image'

export default class Create extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modules: props.modules,
      formats,
      sortmenu: false,
      sort_anchorEl: null,
      owneremployeeid: null,
      letterVariables: [],
      offset: 0,
      limit: 10,
      ticketCategoryList: props.ticketCategoryList,
      selectedticketcategoryid: [],
      ticketcategoryids: props.postData.ticketcategoryids
        ? props.postData.ticketcategoryids.split(",")
        : [],

      employee: [],
      activeStep: 0,
      AllStep: [],
      completed: false,
      postData: props.postData,
      isattachement: false,
      mailbody: "",
      prioritytypeid: 1,
      allemployees: [],
    };
    this.onNextClick = this.onNextClick.bind(this);
    this.updatePostData = this.updatePostData.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.openPoper = this.openPoper.bind(this);
  }

  componentDidMount() {
    const selectAllCtg =
      this.state.postData.ticketcategoryids == "0" ? true : false;
    const selectedticketcategoryid = selectAllCtg
      ? [{ displayvalue: 0 }]
      : this.state.ticketCategoryList.filter(
          (objCtg) =>
            (this.state.postData.ticketcategoryids &&
              this.state.postData.ticketcategoryids
                .split(",")
                .some((tcCtgId) => tcCtgId == objCtg.displayvalue)) ||
            false,
        );

    this.setState({ selectedticketcategoryid, selectAllCtg });

    //   const x = () => {
    //     $("span").removeClass("ql-selected");
    //   };
    //   x();
    //   const placeholderPickerItems = Array.prototype.slice.call(
    //     document.querySelectorAll(".ql-placeholder .ql-picker-item"),
    //   );

    //   placeholderPickerItems.forEach(
    //     (item) => (item.textContent = item.dataset.value),
    //   );
    //   document.querySelector(".ql-placeholder .ql-picker-label").innerHTML =
    //     "{ }";
    //
  }

  getAllEmp() {
    const { login } = this.props.AuthenticationAction;
    const data = {
      featurekey: "reviewform",
      subscriptionid: login.subscriptionid,
    };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        console.log("result: ", result);
        console.log("result.data.result: ", result.data.result);
        this.setState({
          allemployees: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  updatePostData(key, value) {
    const { postData } = this.state;

    postData[key] = `${
      postData.bodyvariableids ? postData.bodyvariableids : ""
    }{${value.variablevalue}}`;

    // if (key == "ticket") {}

    // postData.subjectvariableids = value.displayvalue;
    this.setState({
      postData,
      open: false,
      sortmenu: false,
      sort_anchorEl: null,
    });
  }

  handleChange1(key, value) {
    this.setState({ [key]: value });
  }

  handleChange(key, value, intTicketCategoryid) {
    const { postData, ticketcategoryids } = this.state;

    // if (key == "selectedticketcategoryid") {
    //   this.setState({ [key]: value });
    // }

    if (key == "responsebodypath") {
      postData[key] = value;
      // postData.bodyvariableids = 1;
    }

    // if (key == "ticketcategoryids") {
    //   if (value) {
    //     ticketcategoryids = ticketcategoryids ? ticketcategoryids : [];
    //     ticketcategoryids.push(intTicketCategoryid);
    //   } else {
    //     ticketcategoryids = ticketcategoryids.filter(
    //       (input) => input != intTicketCategoryid,
    //     );
    //   }
    // }

    postData[key] = value;

    this.setState({
      ticketcategoryids,
      postData,
    });
  }

  openPoper(e) {
    this.setState({
      open: !this.state.open,
      create_anchorEl: e.currentTaget,
    });
  }

  onNextClick = (selectedReview) => {
    this.setState(
      {
        selectedReview,
      },
      () => {
        if (this.child) {
          this.child.handleNext();
        }
      },
    );
  };

  onCancel = () => {
    this.props.enqueueSnackbar(` Are you sure, you would lost your progress?`, {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.history.push(`${this.props.match.path}`);
            this.setState({
              postData: {
                savedresponseid: null,
                title: "",
                responsebodypath: null,
                bodyvariableids: [],
                ticketcategoryids: null,
              },
            });
            this.props.closeSnackbar();
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  };

  onPrevClick = () => {
    this.child.handleBack();
  };

  selectAllCtgOnChange() {
    const selectAllCtg = !this.state.selectAllCtg && true;
    const selectedticketcategoryid = selectAllCtg ? [{ displayvalue: 0 }] : [];

    this.setState({ selectedticketcategoryid, selectAllCtg });
  }

  onSave() {
    const { responsebodypath } = this.state.postData;
    const { postData, selectedticketcategoryid } = this.state;
    // const { letterVariables } = this.props;
    const bodyvariableids = [];
    // letterVariables.forEach((x) => {
    //   if (
    //     responsebodypath &&
    //     responsebodypath.includes(`{${x.variablevalue}}`)
    //   ) {
    //     bodyvariableids.push(x.displayvalue);
    //   }
    // });

    const ticketcategoryids =
      selectedticketcategoryid && selectedticketcategoryid.length > 0
        ? selectedticketcategoryid.map((x) => x.displayvalue).join(",")
        : null;

    if (!postData.title) {
      this.props.enqueueSnackbar(" Please enter title of response", {
        variant: "error",
      });
      return;
    } else if (!postData.responsebodypath || postData.responsebodypath == "") {
      this.props.enqueueSnackbar(" Please enter body of response", {
        variant: "error",
      });
      return;
    } else {
      postData.responsebodypath =
        postData.responsebodypath && postData.responsebodypath.toString();
      const data = {
        filename: "cannedreponse.html",
        appproductid: null,
        contenttype: "application/html",
        bufferdata: convertTOBase64(postData.responsebodypath),
        employeeid: null,
      };
      instance.post("employee/uploadbufferfile", data).then((result) => {
        postData.responsebodypath = result.data.result[0].imagepath;
      });

      postData.ticketcategoryids = ticketcategoryids ? ticketcategoryids : 0;
      instance
        .post("helpdesk/createsavedresponse", postData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.history.push(`${this.props.match.path}/list`);
          this.props.getAllSavedResponse(true);

          // this.props.removeSaveProgress();
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
          // this.props.removeSaveProgress();
        });
    }
  }

  render() {
    const { title, responsebodypath } = this.state.postData;
    // const { letterVariables } = this.props.letterVariables;
    return (
      <div>
        <IntlProvider locale="en">
          <div className="content-outer-wrapper" style={{ marginBottom: 80 }}>
            <p className="large-text-dark-secondary margin-bottom-16 t-bold">
              Create new canned response
            </p>

            <Grid container style={{ alignItems: "center" }}>
              <Grid item xs={12} md={8} sm={12}>
                <div>
                  <DynamicForm
                    fields={textinputconverter({
                      value: title,
                      placeholder: "Title should be easily identifiable",
                      label: "Title",
                    })}
                    onChange={(value) => {
                      this.handleChange("title", value);
                    }}
                  />
                </div>
                <Grid container>
                  <Grid item xs={12} md={12} sm={8}>
                    <p className="small-dark-secondary t-bold margin-bottom-8">
                      Response
                    </p>
                    <div className="margin-top-8 margin-bottom-8 pipeline-mail-template canned-responses">
                      <ReactQuill
                        theme="snow"
                        value={responsebodypath || ""}
                        modules={this.state.modules}
                        formats={this.state.formats}
                        onChange={(value) => {
                          this.handleChange("responsebodypath", value);
                        }}
                      />
                    </div>
                  </Grid>
                </Grid>
                {/* <Popover
                  open={this.state.sortmenu}
                  anchorEl={this.state.sort_anchorEl}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  onClose={() =>
                    this.setState({
                      sortmenu: false,
                      sort_anchorEl: null,
                    })
                  }
                  className="margin-top-8"
                >
                  <Paper style={{ width: 250 }}>
                    <List className="cursor-pointer thin-scroll">
                      {letterVariables &&
                        letterVariables
                          .filter(
                            (option) =>
                              option.displayvalue != 999 &&
                              option.displayvalue != 888,
                          )
                          .map((option) => (
                            <ListItem
                              className="padding-right-0 padding-top-2 padding-bottom-2"
                              onClick={() =>
                                this.updatePostData("bodyvariableids", option)
                              }
                              style={{ height: 30 }}
                            >
                              <ListItemText style={{ paddingTop: 11 }}>
                                <p className="small-dark-secondary">
                                  {option.displayname}
                                </p>
                              </ListItemText>
                            </ListItem>
                          ))}
                    </List>
                  </Paper>
                </Popover> */}

                <p className="small-dark-secondary t-bold margin-bottom-8 margin-top-16">
                  Select categories in which you wish to use this response
                </p>

                <div>
                  <DynamicForm
                    fields={multiselectinputconverter({
                      value: this.state.selectAllCtg
                        ? [{ displayname: "all", displayvalue: 0 }]
                        : this.state.selectedticketcategoryid,
                      label: "",
                      placeholder: "",
                      options: this.state.ticketCategoryList,
                      disabled: this.state.selectAllCtg,
                    })}
                    onChange={(id) =>
                      this.handleChange1("selectedticketcategoryid", id)
                    }
                  />
                  <div style={{ marginLeft: -12 }}>
                    <Checkbox
                      checked={this.state.selectAllCtg}
                      onChange={this.selectAllCtgOnChange.bind(this)}
                      value={this.state.selectAllCtg}
                      color="primary"
                    />
                    <span className="input-label">Select all categories</span>
                  </div>
                  {/* {this.state.ticketCategoryList &&
                    this.state.ticketCategoryList.map((option) => (
                      <div className={"padding-left-4"}>
                        {
                          <DynamicForm
                            fields={checkboxinputconverter({
                              value: this.state.ticketcategoryids.find(
                                (intId) => intId == option.displayvalue,
                              ),
                              label: option.displayname,
                            })}
                            onChange={(value) =>
                              this.handleChange(
                                "ticketcategoryids",
                                value,
                                option.displayvalue,
                              )
                            }
                          />
                        }
                      </div>
                    ))} */}
                </div>
              </Grid>
            </Grid>

            <div
              className="width100"
              style={{
                position: "fixed",
                left: 0,
                background: "white",
                bottom: 0,
                padding: 10,
                borderTop: "1px solid #d4d4d4",
                zIndex: 0,
              }}
            >
              <div>
                <div className="floatleft" style={{ marginLeft: 304 }}>
                  <Button
                    className="btn btn-secondary-md-blue margin-right-16"
                    variant="contained"
                    onClick={this.onCancel}
                  >
                    Cancel
                  </Button>
                  {/* <Button
                    className="btn btn-secondary-md-blue margin-right-16"
                    variant="contained"
                    onClick={() => this.onSave()}
                  >
                    Save progress
                  </Button> */}
                </div>
                <div className="floatright" style={{ marginRight: 72 }}>
                  <div>
                    {/* <Button
                      className="btn btn-secondary-md-blue margin-right-16"
                      variant="contained"
                      onClick={() => this.onSave()}
                    >
                      Save & add more
                    </Button> */}
                    <Button
                      className="btn btn-primary-md-blue"
                      variant="contained"
                      onClick={() => this.onSave()}
                    >
                      Save
                    </Button>
                  </div>
                </div>
                <div className="clearfloat"></div>
              </div>
            </div>
          </div>
        </IntlProvider>
      </div>
    );
  }
}
